export default __webpack_public_path__ + "static/media/findclass.a7b489bc.mp4";